module.exports = __webpack_public_path__ + "img/logo_1.37eb43f4.png";